import { Layout } from './layout';
import { Loading } from './loading';

export function UpcomingConferencesEventsWidgetLoading() {
  return (
    <Layout>
      <Loading />
    </Layout>
  );
}
